// components
import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';

type SellingPriceProps = {
    formattedPrice: string;
};

export const SellingPrice = ({ formattedPrice }: SellingPriceProps) => {
    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            <Typography variant="body-md" color="sem.color.on-surface.muted" tag="span">
                Selling Price:
            </Typography>
            <Typography variant="body-md" tag="span">
                {formattedPrice}
            </Typography>
        </Box>
    );
};
